import Vuex from 'vuex'
import Vue from 'vue'
import { modalModule } from './modalModule.js'

Vue.use(Vuex)

const BaseStore = new Vuex.Store({
  state: {
    currentAnimation: 'slide-left',
    tabLastPages: {},
    lastKnownPage: null,
    currentPage: null,
    showMyLockersOnly: false,
  },
  modules: {
    modal: modalModule,
  },
  mutations: {
    setCurrentAnimation(state, newVal) {
      state.currentAnimation = newVal
    },
    memoLastPage(state, route) {
      let base = route.path.match(/\/([\w-]+)[\/]{0,1}.*/i)
      if (base && base.length) {
        base = base[1]
      } else {
        base = 'mainpage'
      }
      state.lastKnownPage = state.currentPage
      state.currentPage = route
      state.tabLastPages[base] = route
    },
    removeLastPage(state, route) {
      let base = route.path.match(/\/([\w-]+)[\/]{0,1}.*/i)
      if (base && base.length) {
        base = base[1]
      } else {
        base = 'mainpage'
      }
      state.tabLastPages[base] = null
    },
    setShowMyLockersOnly(state, value) {
      state.showMyLockersOnly = value
    },
  },
  getters: {
    currentAnimation: state => {
      return state.currentAnimation
    },
    lastKnownPage: state => {
      return state.lastKnownPage || '/'
    },
    lastPageFor: state => base => {
      if (!base || !base.length) {
        base = 'mainpage'
      }
      let result = state.tabLastPages[base]
      if (!result) {
        result = `/${base}`
      }
      return result
    },
    showMyLockersOnly: state => {
      return state.showMyLockersOnly
    },
  },
})

export default BaseStore
